export default {
  init() {
    // JavaScript to be fired on all pages
    $('.navbar-collapse').on('show.bs.collapse', function () {
      $('.navbar').addClass('is-open');
    })

    $('.navbar-collapse').on('hide.bs.collapse', function () {
      $('.navbar').removeClass('is-open');
    })

    $('.collapse').on('show.bs.collapse', function () {
      $(this).prev().find('.plus-button').addClass('is-open');
    })

    $('.collapse').on('hide.bs.collapse', function () {
      $(this).prev().find('.plus-button').removeClass('is-open');
    })

    var $hamburger = $('.hamburger');
    $hamburger.on('click', function () {
      $hamburger.toggleClass('is-active');
    });

    $.featherlight.prototype.afterContent = function () {
      var title = this.$currentTarget.attr('data-featherlight-title');
      var caption = this.$currentTarget.attr('data-featherlight-caption');
      this.$instance.find('.caption').remove();
      this.$instance.find('.title').remove();
      $('<div class="container-fluid">').prependTo(this.$instance.find('.featherlight-content'));
      $('<div class="row">').prependTo(this.$instance.find('.featherlight-content .container-fluid'));
      $('<div class="col-md-5 caption">').text(caption).prependTo(this.$instance.find('.featherlight-content .row'));
      $('<div class="col-md-5 title">').text(title).prependTo(this.$instance.find('.featherlight-content .row'));
    }

    $('.slider').each(function (key) {
      var sliderIdName = 'slider' + key;
      this.id = sliderIdName;
      var sliderId = '#' + sliderIdName;
      var $status = $(sliderId).next().find('.slider__counter .slider__current span');
      var $total = $(sliderId).next().find('.slider__counter .slider__total span');
      var $captionContainer = $(sliderId).next().find('.slider__counter .slider__current .slider__caption');

      $(sliderId).on('init reInit afterChange', function (event, slick, currentSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        // eslint-disable-next-line no-undef
        var $slideCaption = $(slick.$slides.get(currentSlide)).find('.contentslider__image').data('slide-caption');
        var $slideCaptionFallback = $(sliderId).data('slide-headline');

        if ($slideCaption) {
          $captionContainer.text($slideCaption);
        } else {
          $captionContainer.text($slideCaptionFallback);
        }

        if (i <= 9) {
          $status.text(' ' + i);
        } else {
          $status.text(i);
        }

        if (slick.slideCount <= 9) {
          $total.text(' ' + slick.slideCount);
        } else {
          $total.text(slick.slideCount);
        }
      });

      $(sliderId).slick({
        arrows: false,
        autoplay: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      });

      $(sliderId).next().find('.slider__arrow--prev').click(function () {
        $(sliderId).slick('slickPrev');
      })

      $(sliderId).next().find('.slider__arrow--next').click(function () {
        $(sliderId).slick('slickNext');
      })

    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js